// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import L from 'leaflet';
import myw from 'myWorld/base/core';
import 'L.GoogleMutant';

/* globals google:false */

//returns a method that delegates the call to the L.GoogleMutant instance
function delegateMethod(methodName) {
    return function(...args) {
        if (this._mutant) this._mutant[methodName](...args);
    };
}

myw.GoogleBasemap = L.Layer.extend({
    options: {
        pane: 'tilePane',
        opacity: 1,
        type: 'satellite'
    },

    // Possible types: SATELLITE, ROADMAP, HYBRID, TERRAIN
    initialize(datasource, type, options) {
        const mapTypeId = google.maps.MapTypeId[type];
        L.setOptions(
            this,
            _.extend(
                {
                    type: mapTypeId,
                    maxZoom: 21 //we don't want to restrict the map to only zoom 18 as defined in L.GridLayer.GoogleMutant
                },
                options
            )
        );

        this.datasource = datasource;
    },

    onAdd(map) {
        this._map = map;

        this._mutant = L.gridLayer.googleMutant(this.options);
        this._mutant.addTo(map);

        this._mutant.on(
            'spawned',
            function(ev) {
                this._googleMap = ev.mapObject;
            },
            this
        );
        //pass through pegman events
        this._mutant.on('pegman-mousedown', this.fire.bind(this, 'pegman-mousedown'));

        return this;
    },

    onRemove(map) {
        this._mutant.remove();
        this._map = null;

        return this;
    },

    redraw: delegateMethod('redraw'),

    addGoogleLayer(googleLayer) {
        googleLayer.setMap(this._googleMap);
    },

    showPegman: delegateMethod('showPegman'),

    setStreetView: delegateMethod('setStreetView')
});

export default myw.GoogleBasemap;
